const DEFAULT_BRANDING = {
  appName: 'Report Engine',
  logoText: 'Report Engine',
  logoIconUrl: null,
  faviconUrl: null,
  accentColor: '#89b4fa',
  bgPrimary: '#1e1e2e',
  bgSecondary: '#181825',
  bgSurface: '#313244',
  textPrimary: '#cdd6f4',
  textSecondary: '#a6adc8',
  borderColor: '#45475a',
};

const STORAGE_KEY = 'aic_branding';

export function getDefaultBranding() {
  return { ...DEFAULT_BRANDING };
}

export function loadBrandingFromStorage() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return getDefaultBranding();
    const parsed = JSON.parse(raw);
    return { ...DEFAULT_BRANDING, ...parsed };
  } catch {
    return getDefaultBranding();
  }
}

export function saveBrandingToStorage(branding) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(branding));
}

export function applyBranding(brandingInput) {
  const branding = { ...DEFAULT_BRANDING, ...(brandingInput || {}) };
  const root = document.documentElement;

  root.style.setProperty('--accent', branding.accentColor);
  root.style.setProperty('--accent-hover', branding.accentColor);
  root.style.setProperty('--bg-primary', branding.bgPrimary);
  root.style.setProperty('--bg-secondary', branding.bgSecondary);
  root.style.setProperty('--bg-surface', branding.bgSurface);
  root.style.setProperty('--text-primary', branding.textPrimary);
  root.style.setProperty('--text-secondary', branding.textSecondary);
  root.style.setProperty('--border', branding.borderColor);

  document.title = branding.appName;

  let faviconEl = document.querySelector('link[rel="icon"]');
  if (!faviconEl) {
    faviconEl = document.createElement('link');
    faviconEl.setAttribute('rel', 'icon');
    document.head.appendChild(faviconEl);
  }

  if (branding.faviconUrl) {
    faviconEl.setAttribute('href', branding.faviconUrl);
  }

  saveBrandingToStorage(branding);
  return branding;
}
